/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useDispatch, useSelector } from "react-redux";
import EditPriceItem from "../../EditPriceItem/EditPriceItem";
import CurrencyFormat from "react-currency-format";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { Radio } from "@rmwc/radio";
import { Checkbox } from "@rmwc/checkbox";
import {   changeLeantoPosition, extraItemsAction, hasDoublelegBaiserail, selectedTrussForLean, setBuildingFlags } from "../../../action";
import { useState } from "react";
import { changeBuildingRoof,changeBuildingDimension } from "../../../action/building/building_style/buildingStyle.action.js";
import Dropdown from "../../Dropdown/SizeDropdown";
import { getLeantoRoofPitchLabel } from "../../../utils/Functions";
import { capitalize } from "../../../redux/reducers/utils";
import { LEAN_TYPE_NUM_TO_STR } from "../../../Constants/constant";
import RoofStyleSetting from "../BuildingSize/RoofStyleSetting.jsx";
import GaugeSetting from "../BuildingSize/GaugeSetting.jsx";
import CrossBracing from "../BuildingSize/CrossBracing.jsx";


const leftRightAlignments = [
	{ value: 2, label: "Front" },
	{ value: 3, label: "Back" },
	{ value: 1, label: "Center" },
	{ value: 4, label: "Custom" }
];

const frontBackAlignments = [
	{ value: 2, label: "Left" },
	{ value: 3, label: "Right" },
	{ value: 1, label: "Center" },
	{ value: 4, label: "Custom" }
];

const RenderLean = ({ lean, leanType }) => {
	const eventKey = useSelector((state) => state.reducer.const_var.navEventKey.leanto);
	const const_var = useSelector((state) => state.reducer.const_var);
	const params = useSelector((state) => state.reducer.params);
	const dispatch = useDispatch();

	const [shouldShowLegHeightOptions, setShouldShowLegHeightOption] = useState(false);

	const leanIndex = const_var.post_data?.building?.leanto?.findIndex((lean) => LEAN_TYPE_NUM_TO_STR[lean.leanto_type] === leanType);

	const wrappedLengthContent = getWrappedContent(params, leanType);

	const isGableLean = params.leanStyle[leanType] === "gable";

	const obj = {
		leftFront: params.add_left_front_lean_porch,
		rightFront: params.add_right_front_lean_porch,
		leftBack: params.add_left_back_lean_porch,
		rightBack: params.add_right_back_lean_porch
	};

	const { width, widthKey, widthOptions, length, lengthKey, lengthOptions, height, heightKey, heightOptions, hasDoubleLegShowKey } = getMeData(leanType, isGableLean, const_var, params);

	const shouldShowLegs = (shouldShowLegHeightOptions || const_var.commonBuildingFlag[leanType + "Lean"].leanHeight == true) && const_var[hasDoubleLegShowKey] === true;

	const shouldShowAlignment = (isGableLean ? width : length) < ((leanType === "front" || leanType === "back") ? params.p_w : params.p_d)

	const handleDimensionChange = (value, str) => {
		if (isGableLean) {
			const_var.checkforLeanto = true;
		}
		dispatch(
			changeBuildingDimension({
				val: value,
				str: str,
				checkLean: leanType,
				checkCustomDimension: "",
				secondParam: "",
				...obj
			})
		);
	};

	const handleHeightChange = (value, str) => {
		if (isGableLean) {
			const_var.checkforLeanto = true;
		}
		setShouldShowLegHeightOption(true);

		dispatch(
			changeBuildingDimension({
				val: value,
				str: str,
				checkLean: leanType,
				checkCustomDimension: "",
				secondParam: "",
				valueToSet: !shouldShowLegHeightOptions,
				...obj
			})
		);
	};

	const toggleLegsOptionsVisibilty = () => {
		setShouldShowLegHeightOption((prevState) => !prevState);
		dispatch(setBuildingFlags(leanType + "Lean", undefined, shouldShowLegHeightOptions));
	};

	const getWrappedLength = (leanType) => {
		let leantolength = "";
		if (leanIndex != -1) {
			if (leanType == "left" || leanType == "right") {
				leantolength = lean.porch?.length ?? null;
			} else {
				leantolength = lean.wrappedLength ?? null;
			}
		}
		return leantolength != "" && leantolength != null ? "Wrapped Length " + leantolength + "'" : null;
	};

	return (
		<div className={const_var.is_loader == true && eventKey == `${leanType}Lean` ? "card-body-inner disabled" : "card-body-inner"}>
			<div className={"leant-to-wrapper"}>
				{/* Width & Length */}
				<div className="form-group">
					<div className="control-label-bar">
						<label className="control-label">Width & Length</label>
						<div className="control-label-action">
							<ShowPrice price_for="basic_price" lean={lean} leanIndex={leanIndex} leanType={leanType} />
						</div>
						<div className="control-label-action ml-auto">
							{wrappedLengthContent != "" && wrappedLengthContent.length > 0 && (
								<div className="wrapped-length-container">
									<div className="wrapped-length-text">{getWrappedLength(leanType)}</div>
									<OverlayTrigger
										placement="bottom"
										trigger="hover"
										overlay={
											<Popover className="framelength-popover">
												<Popover.Content>
													<p className="mb-0 f-12 ">{wrappedLengthContent}</p>
												</Popover.Content>
											</Popover>
										}
									>
										<span className="icon-information-square-filled icon ml-1 wrapped-length-icon"></span>
									</OverlayTrigger>
								</div>
							)}
						</div>
					</div>
					<div className="floating-label-input floating-input-group">
						<Dropdown onChange={(value) => handleDimensionChange(value, widthKey)} value={width} options={widthOptions} />
						<Dropdown onChange={(value) => handleDimensionChange(value, lengthKey)} value={length} options={lengthOptions} />
					</div>
				</div>

				{/* Height & Legs */}
				<div className="form-group">
					<div className="control-label-bar">
						<label className="control-label">Height</label>
						<div className="control-label-action justify-content-start">
							<ShowPrice price_for="height_price" lean={lean} leanIndex={leanIndex} leanType={leanType} />
						</div>
					</div>
					<div className="row no-gutters">
						<div className="col-6">
							<div className="floating-label-input">
								<Dropdown onChange={(value) => handleHeightChange(value, heightKey)} value={height} options={Object.entries(heightOptions).map(([key, value]) => ({ value: value, label: key }))} />
							</div>
						</div>
						{const_var[hasDoubleLegShowKey] && (
							<div className="col-6">
								<a className="more-link" onClick={toggleLegsOptionsVisibilty}>
									<span className="text">Leg Height Options</span>
									<span className="icon">
										<i className="icon-arrow-down-ico"></i>
									</span>
								</a>
							</div>
						)}
					</div>

					{/* Legs */}
					{shouldShowLegs && <Legs leanType={leanType} lean={lean} />}
				</div>

				{/* Alignment & Roof Pitch */}
				<div className="form-group">
					
					{/* Roof Style & Pitch */}
					<div className="row">
						
						{isGableLean ? <div className="col"><RoofStyleSetting /></div> : shouldShowAlignment && <Alignment leanType={leanType} isGableLean={isGableLean}/>}
						
						<RenderRoofPitchOptions lean={lean} leanIndex={leanIndex} leanType={leanType} />
					</div>
					
					<div className="row">
						{isGableLean && shouldShowAlignment && <Alignment leanType={leanType} isGableLean={isGableLean}/>}
					</div>
				</div>


				{/* Truss */}
				{isGableLean && <Truss lean={lean} leanIndex={leanIndex} leanType={leanType} />}

				{/* Common for all lean type and center building */}
				{isGableLean && <GaugeSetting/>}
				{isGableLean && <CrossBracing leanType={leanType} lean={lean} />}
			</div>
		</div>
	);
};

const ShowPrice = ({ lean, leanIndex, leanType, price_for }) => {
	const const_var = useSelector((state) => state.reducer.const_var);
	if (const_var.loginSession) {
		return (
			<div className="price-box">
				<EditPriceItem
					is_disabled={lean === undefined}
					jsonObj={lean !== undefined ? lean[price_for] : 0}
					jsonIsLeanto={lean !== undefined ? leanType : undefined}
					jsonObjIndex={leanIndex}
					jsonObjKey={lean !== undefined ? price_for : undefined}
				/>
			</div>
		);
	} else {
		return (
			<div className="price-box-type-2">
				{const_var.hide_price_calculation != 1 && lean !== undefined && lean[price_for] !== 0 && <CurrencyFormat value={lean[price_for]} displayType={"text"} thousandSeparator={true} prefix={"$"} />}
			</div>
		);
	}
};

const Legs = ({ leanType, lean }) => {
	const const_var = useSelector((state) => state.reducer.const_var);
	const params = useSelector((state) => state.reducer.params);
	const dispatch = useDispatch();
	const isGableLean = params.leanStyle[leanType] === "gable";

	// let showEndCrossBracing = false;
	// let showEndCrossBracingDisabled = false;

	// let showSideCrossBracing = false;
	// let showSideCrossBracingDisabled = false;

	// if(isGableLean){
	// 	if ((lean.pricing_data.side_cross_bracing != undefined) && lean.pricing_data.side_cross_bracing.length > 0) {
	// 		if ((lean.pricing_data.side_cross_bracing != undefined) && lean.pricing_data.side_cross_bracing.length > 0 && lean.pricing_data.side_cross_bracing[0].is_default != 'no') {
	// 			showSideCrossBracing = true;
	// 			if (lean.pricing_data.side_cross_bracing[0].is_default == "included") {
	// 			showSideCrossBracingDisabled = true;
	// 			}
	// 		} else {
	// 			showSideCrossBracing = false;
	// 		}
	// 	} else {
	// 		showSideCrossBracing = false;
	// 		showSideCrossBracingDisabled = false;
	// 	}

	// 	if ((lean.pricing_data.addons_width) && lean.pricing_data.addons_width.length > 0 && lean.pricing_data.addons_width[0].end_cross_bracing != undefined && lean.pricing_data.addons_width[0].end_cross_bracing != 0) {
	// 		showEndCrossBracing = true;
	// 	} else if ((lean.pricing_data.end_cross_bracing != undefined) && lean.pricing_data.end_cross_bracing.length > 0) {
	// 		if ((lean.pricing_data.end_cross_bracing != undefined) && lean.pricing_data.end_cross_bracing.length > 0 && lean.pricing_data.end_cross_bracing[0].is_default != 'no') {
	// 		showEndCrossBracing = true;
	// 		if (lean.pricing_data.end_cross_bracing[0].is_default == "included") {
	// 			showEndCrossBracingDisabled = true;
	// 		}
	// 		} else {
	// 		showEndCrossBracing = false;
	// 		}
	// 	} else {
	// 		showEndCrossBracing = false;
	// 		showEndCrossBracingDisabled = false;
	// 	}
	// }

	const { hasDoubleLegShowKey, hasDoubleLegNameKey, parmasLegKey, selectedLegType } = getMeData(leanType, isGableLean, const_var, params);

	const getLabel = (data) => {
		if (!const_var.isSingleBaseRail && !data.name.includes("Baserails")) {
			if (params.m_s_n == 122 && data.legs_type == "double") {
				return `${data.name} / Double Baserail`;
			} else {
				if (!data.name.includes("Baserails") && data.name != "Double Legs") {
					return data.name + " Baserail";
				} else {
					return data.name;
				}
			}
		} else {
			return data.name;
		}
	};

	const getLabel2 = () => {
		const name = const_var[hasDoubleLegNameKey];
		if (params.m_s_n == 122 && name?.toLowerCase()?.includes("double") && !name.includes("Baserails")) {
			return `${name} / Double Baserail`;
		} else {
			if (!name.includes("Baserails") && name != "Double Legs") {
				return name + " Baserail";
			} else {
				if (name.includes("Baserails") && name.includes("Ladder")) {
					return name;
				} else {
					return "Double Legs";
				}
			}
		}
	};
	let hasDoubleLegDisabled = leanType == 'left' ? const_var.leanHasDoublelegdisable : leanType == 'right' ? const_var.leanRHasDoublelegdisable : leanType == 'back' ? const_var.leanBHasDoublelegdisable : const_var.leanFHasDoublelegdisable

	let isEndPRiceDisabled = ((leanType == 'left' && params.added_building_bracing.p_e_c_b_l === true) || (leanType == 'right' && params.added_building_bracing.p_e_c_b_r === true) || (leanType == 'front' && params.added_building_bracing.p_e_c_b_f === true) || (leanType == 'back' && params.added_building_bracing.p_e_c_b_b === true)) ? "false" : "true"

	let isSidePriceDisabled = ((leanType == 'left' && params.added_building_bracing.p_s_c_b_l === true) || (leanType == 'right' && params.added_building_bracing.p_s_c_b_r === true) || (leanType == 'front' && params.added_building_bracing.p_s_c_b_f === true) || (leanType == 'back' && params.added_building_bracing.p_s_c_b_b === true)) ? "false" : "true"
	
	return (
		<div className="more-info">
			<p>The Reinforced/Double/Ladder/ZigZag legs strengthen the building and are required for taller buildings.</p>
			{const_var[hasDoubleLegShowKey] === true && const_var.ConditionArrForLean?.[leanType]?.CustomArray?.length > 1 ? (
				const_var.ConditionArrForLean[leanType].CustomArray.map((data) => {
					return (
						<div className="radio-group">
							<Radio
								name={leanType + "Lean"}
								label={getLabel(data)}
								value={data.name}
								checked={selectedLegType == data.legs_type && params[parmasLegKey]}
								onChange={(e) => dispatch(hasDoublelegBaiserail(e.target.value, leanType + "Lean", data))}
							/>
						</div>
					);
				})
			) : (
				<>
					{const_var[hasDoubleLegShowKey] == true ? (
						<div className="check-group">
							<Checkbox
								className="secondary"
								ripple="RipplePropF"
								disabled={hasDoubleLegDisabled}
								label={getLabel2()}
								checked={params[parmasLegKey]}
								onChange={(e) => dispatch(hasDoublelegBaiserail(e.target.value, leanType + "Lean"))}
							/>
						</div>
					) : null}
				</>
			)}
			{/* {(isGableLean && showEndCrossBracing == true) ?
				<div className='check-group'>
					<Checkbox
						ripple="RipplePropF"
						checked={leanType == 'left' ? params.added_building_bracing.p_e_c_b_l : leanType == 'right' ? params.added_building_bracing.p_e_c_b_r : leanType == 'front' ? params.added_building_bracing.p_e_c_b_f : params.added_building_bracing.p_e_c_b_b}
						disabled={showEndCrossBracingDisabled}
						label="End Cross Bracings"
						onChange={e =>
							dispatch(extraItemsAction(e.target.value,leanType + '-ecbracing'))
						}
					/>
					<div className='price-box'>
						{((const_var.post_data.building !== undefined && const_var.loginSession == true)) ?
							<EditPriceItem is_disabled={isEndPRiceDisabled} jsonObj={'extraitems'} jsonObjValue={leanType == 'left' ? params.added_building_bracing.p_e_c_b_l : leanType == 'right' ? params.added_building_bracing.p_e_c_b_r : leanType == 'front' ? params.added_building_bracing.p_e_c_b_f : params.added_building_bracing.p_e_c_b_b} jsonObjKey="End Cross Bracing" />
							: null
						}
					</div>
				</div>
				: null
			}
			{(isGableLean && showSideCrossBracing == true) ?
				<div className='check-group'>
					<Checkbox
						ripple="RipplePropF"
						checked={leanType == 'left' ? params.added_building_bracing.p_s_c_b_l : leanType == 'right' ? params.added_building_bracing.p_s_c_b_r : leanType == 'front' ? params.added_building_bracing.p_s_c_b_f : params.added_building_bracing.p_s_c_b_b}
						disabled={showSideCrossBracingDisabled}
						label="Side Cross Bracing"
						onChange={e =>
							dispatch(extraItemsAction(e.target.value,leanType + '-scbracing'))
						}
					/>
					<div className='price-box  '>
						{((const_var.post_data.building !== undefined)) ?
							<EditPriceItem is_disabled={isSidePriceDisabled}  jsonObj={'extraitems'} jsonObjValue={leanType == 'left' ? params.added_building_bracing.p_s_c_b_l : leanType == 'right' ? params.added_building_bracing.p_s_c_b_r : leanType == 'front' ? params.added_building_bracing.p_s_c_b_f : params.added_building_bracing.p_s_c_b_b} jsonObjKey="Side Cross Bracing" />
							: null
						}
					</div>
				</div>
			: null
			} */}
		</div>
	);
};

const Alignment = ({ leanType, isGableLean }) => {
	const params = useSelector((state) => state.reducer.params);
	const dispatch = useDispatch();

	let leanToAlignmentKey = "";

	if (leanType === "left") {
		leanToAlignmentKey = "leantoAlignmentLeft";
	}
	if (leanType === "right") {
		leanToAlignmentKey = "leantoAlignmentRight";
	}
	if (leanType === "front") {
		leanToAlignmentKey = "leantoAlignmentFront";
	}
	if (leanType === "back") {
		leanToAlignmentKey = "leantoAlignmentBack";
	}
	
	let alignmentOptions = leanType === "front" || leanType === "back" ? frontBackAlignments : leftRightAlignments;


	return (
		<div className="col">
			<div className="control-label-bar">
				<label className="control-label">Alignment</label>
				<OverlayTrigger
					placement="top"
					trigger="hover"
					overlay={
						<Popover className="popover-default">
							<Popover.Content>{isGableLean ?" Drag & Drop ": "Drag & Drop Lean-To"}</Popover.Content>
						</Popover>
					}
				>
					<i className="control-label-info icon-drag-ico"></i>
				</OverlayTrigger>
			</div>
			{Object.entries(alignmentOptions).map(([_, value], index) => {
				if (index === 3 && parseInt(params[leanToAlignmentKey]) !== index + 1) {
					return null;
				}
				return (
					<div className="radio-group">
						<Radio
							label={value.label}
							value={value.value}
							disabled={index === 3}
							checked={parseInt(params[leanToAlignmentKey]) == value.value}
							name={params[leanToAlignmentKey] + capitalize(leanType)}
							onChange={(e) => dispatch(changeLeantoPosition({ event: e.target.value, value: leanType }))}
						/>
					</div>
				);
			})}
		</div>
	);
};

const RenderRoofPitchOptions = ({ lean, leanIndex, leanType }) => {
	const const_var = useSelector((state) => state.reducer.const_var);
	const params = useSelector((state) => state.reducer.params);
	const dispatch = useDispatch();
	const isGableLean = params.leanStyle[leanType] === "gable";

	const dropArr = [];

	const tempBuildingName = const_var.defaultBuildingArr[const_var.BuldingIDforReset] && const_var.defaultBuildingArr[const_var.BuldingIDforReset]?.image_name.split(".").includes("Straight_Roof_Barns");

	const isEligible = params.m_s_n === 3 && tempBuildingName && !const_var.crmSetting.is_Edit;

	if (isGableLean) {
		if (Array.isArray(lean.pricing_data?.roof_pitch) && lean.pricing_data?.roof_pitch?.length > 0) {
			lean.pricing_data.roof_pitch
				.forEach((rp) => {
					if(rp.roof_ids.includes(params.p_r_s) || rp.roof_ids.includes("0")){
						dropArr.push({ value: rp.roof_pitch[0], label: rp.custom_name ?? rp.roof_pitch });
					}
				});
		}
	} else {
		for (const [key, value] of Object.entries(const_var.BuildingLRoofPitch)) {
			if (isEligible) {
				if (const_var.checkRoofDefault != undefined && const_var.checkRoofDefault[0] === value) {
					dropArr.push({ value, label: key });
				}
			} else {
				dropArr.push({ value, label: key });
			}
		}
	}

	dropArr.sort((a, b) => parseInt(a.value) - parseInt(b.value));

	let roofPitchValue = null;

	if (leanType == "left") {
		roofPitchValue = params.b_l_t_r_p;
	}
	if (leanType == "right") {
		roofPitchValue = params.b_l_t_r_pR;
	}
	if (leanType == "front") {
		roofPitchValue = params.b_l_t_r_pF;
	}
	if (leanType == "back") {
		roofPitchValue = params.b_l_t_r_pB;
	}

	if(dropArr.length === 0) {	
		return null;
	}

	return (
		<div className="col">
			<div className="form-group">
				<div className="control-label-bar justify-content-start">
					<label className="control-label">Roof Pitch</label>
				</div>
				{dropArr.map((item) => {
					let roofStyleExist = false
					const label = getLeantoRoofPitchLabel(item.label);
					if(const_var.leanto_roof_pitch_obj?.[item.label]?.roof_ids){
						roofStyleExist = const_var.leanto_roof_pitch_obj?.[item.label]?.roof_ids.includes('0') || const_var.leanto_roof_pitch_obj?.[item.label]?.roof_ids.includes(params.p_r_s)
					}
					if(!roofStyleExist){
						return null
					}
					return (
						<div className="radio-group">
							<Radio
								label={label}
								value={item.value}
								checked={roofPitchValue == item.value}
								name={roofPitchValue + " Roof Pitch" + capitalize(leanType)}
								onChange={(e) => dispatch(changeBuildingRoof({ event: e.target.value, value: leanType }))}
							/>
							{roofPitchValue == item.value && <ShowPrice price_for="roof_pitch_price" lean={lean} leanIndex={leanIndex} leanType={leanType} />}
						</div>
					);
				})}
			</div>
		</div>
	);
};

const Truss = ({ lean, leanIndex, leanType }) => {
	const const_var = useSelector((state) => state.reducer.const_var);
	const params = useSelector((state) => state.reducer.params);

	const dispatch = useDispatch();

	const isGableLean = params.leanStyle[leanType] === "gable";

	if (!isGableLean) {
		return;
	}

	let leanWidth = null, leanData = null;

	if (leanType == "left") {
		leanWidth = params.lean_p_w;
		leanData = const_var.leanGetDataLeft;
	}
	if (leanType == "right") {
		leanWidth = params.leanR_p_w;
		leanData = const_var.leanGetDataRight;
	}
	if (leanType == "front") {
		leanWidth = params.leanF_p_w;
		leanData = const_var.leanGetDataFront;
	}
	if (leanType == "back") {
		leanWidth = params.leanB_p_w;
		leanData = const_var.leanGetDataBack;
	}
	leanData = JSON.parse(JSON.stringify(leanData))

	const isInRange = (truss) => leanWidth <= truss.max_width && leanWidth >= truss.min_width;

	const allTrusses = leanData?.truss_name ?? [];
	
	let eligbleTrusses = []

	if (allTrusses.length > 0) {
		eligbleTrusses = allTrusses.filter((truss) => isInRange(truss));
		const checkpoint = allTrusses.filter((truss) => truss.is_show && isInRange(truss))?.[0];
		if (!eligbleTrusses || !checkpoint) {
			return;
		}
	} 

	const filteredTrusses = [];

	eligbleTrusses.map((truss) => {
		if (truss.is_default != undefined) {
			let trussLabel = "";

			let standardTrussLabel = "Standard Truss";
			if (params.m_s_n == 153 && params.p_r_s == 3) {
				standardTrussLabel = "Vertical Truss";
			}

			if (truss.label) {
				trussLabel = truss.label;
			} else {
				trussLabel = truss.is_default ? standardTrussLabel : params.m_s_n == 153 ? "Ladder Truss" : "High Truss";
			}

			filteredTrusses.push({ ...truss, trussLabel: trussLabel });
		}
	});

	const shouldShowPrice = lean != undefined && const_var.loginSession;

	const canEditPrice = const_var.hide_price_calculation != 1 && const_var.loginSession == false && lean.truss_price !== undefined && lean.truss_price !== 0;

	return (
		<>
			<div className="form-group">
				<label className="control-label">Truss</label>
				<>
					{shouldShowPrice ? (
						<div className="price-box">
							<EditPriceItem jsonIsLeanto={leanType} jsonObjIndex={leanIndex} jsonObj={lean.truss_price ?? 0} jsonObjKey="truss_price" />
						</div>
					) : (
						<div className="price-box-type-2">{canEditPrice && <CurrencyFormat value={lean.truss_price} displayType={"text"} thousandSeparator={true} prefix={"$"} />}</div>
					)}
				</>

				{filteredTrusses.map((item) => {
					return (
						<div className="radio-group">
							<Radio label={item.trussLabel} value={params.l_t_p[leanType].trussId} checked={params.l_t_p[leanType].trussId === item.id} onChange={() => dispatch(selectedTrussForLean(item, leanType))} />
						</div>
					);
				})}
			</div>
		</>
	);
};

const getWrappedContent = (params, leanType) => {
	let wrappedLengthContent = "";

	if (leanType === "left") {
		if (params.add_left_front_lean_porch == true && params.add_left_back_lean_porch == false) {
			wrappedLengthContent = "This wrap length includes Front and Left Lean-To.";
		} else if (params.add_left_back_lean_porch == true && params.add_left_front_lean_porch == false) {
			wrappedLengthContent = "This wrap length includes Back and Left Lean-To.";
		} else if (params.add_left_front_lean_porch == true && params.add_left_back_lean_porch == true) {
			wrappedLengthContent = "This wrap length includes Front, Back and Left Lean-To.";
		} else {
			wrappedLengthContent = "";
		}
		return wrappedLengthContent;
	}

	if (leanType === "right") {
		if (params.add_right_front_lean_porch == true && params.add_right_back_lean_porch == false) {
			wrappedLengthContent = "This wrap length includes Front and Right Lean-To.";
		} else if (params.add_right_back_lean_porch == true && params.add_right_front_lean_porch == false) {
			wrappedLengthContent = "This wrap length includes Back and Right Lean-To.";
		} else if (params.add_right_front_lean_porch == true && params.add_right_back_lean_porch == true) {
			wrappedLengthContent = "This wrap length includes Front, Back and Right Lean-To.";
		} else {
			wrappedLengthContent = "";
		}
		return wrappedLengthContent;
	}

	if (leanType === "front") {
		if (params.add_right_front_lean_porch == true && params.add_left_front_lean_porch == false) {
			wrappedLengthContent = "This wrap length includes Front and Right Lean-To.";
		} else if (params.add_left_front_lean_porch == true && params.add_right_front_lean_porch == false) {
			wrappedLengthContent = "This wrap length includes Front and Left Lean-To.";
		} else if (params.add_left_front_lean_porch == true && params.add_right_front_lean_porch == true) {
			wrappedLengthContent = "This wrap length includes Front, Left and Right Lean-To.";
		} else {
			wrappedLengthContent = "";
		}
		return wrappedLengthContent;
	}

	if (leanType === "back") {
		if (params.add_right_back_lean_porch == true && params.add_left_back_lean_porch == false) {
			wrappedLengthContent = "This wrap length includes Back and Right Lean-To.";
		} else if (params.add_left_back_lean_porch == true && params.add_right_back_lean_porch == false) {
			wrappedLengthContent = "This wrap length includes Back and Left Lean-To.";
		} else if (params.add_left_back_lean_porch == true && params.add_right_back_lean_porch == true) {
			wrappedLengthContent = "This wrap length includes Back, Left and Right Lean-To.";
		} else {
			wrappedLengthContent = "";
		}
		return wrappedLengthContent;
	}
};

const getMeData = (leanType, isGableLean, const_var, params) => {
	let width = null, widthKey = null, widthOptions = null;
	let length = null, lengthKey = null, lengthOptions = null;
	let height = null, heightKey = null, heightOptions = null;
	let hasDoubleLegShowKey = "", hasDoubleLegNameKey = "", parmasLegKey = "";
	let selectedLegType = ""

	if (leanType === "left") {
		width = params.lean_p_w;
		widthKey = "lean_w";
		widthOptions = const_var.dimensionsLeanLW;

		length = params.lean_p_d;
		lengthKey = "lean_l";
		lengthOptions = const_var.dimensionsLeanLD;

		height = params.lean_p_h;
		heightKey = "lean_h";
		heightOptions = const_var.dimensionsLeanLH;

		hasDoubleLegShowKey = "leanHasDoublelegshow";
		hasDoubleLegNameKey = "leanHasDoublelegName";
		parmasLegKey = "lean_p_e_l";
		selectedLegType = const_var.leanLegstype
	}

	if (leanType === "right") {
		width = params.leanR_p_w;
		widthKey = "leanR_w";
		widthOptions = const_var.dimensionsLeanLWR;

		length = params.leanR_p_d;
		lengthKey = "leanR_l";
		lengthOptions = const_var.dimensionsLeanLDR;

		height = params.leanR_p_h;
		heightKey = "leanR_h";
		heightOptions = const_var.dimensionsLeanLHR;

		hasDoubleLegShowKey = "leanRHasDoublelegshow";
		hasDoubleLegNameKey = "leanRHasDoublelegName";
		parmasLegKey = "leanR_p_e_l";
		selectedLegType = const_var.leanRLegstype
	}

	if (leanType === "front") {
		width = params.leanF_p_w;
		widthKey = "leanF_w";
		widthOptions = const_var.dimensionsLeanLWF;

		length = params.leanF_p_d;
		lengthKey = "leanF_l";
		lengthOptions = const_var.dimensionsLeanLDF;

		height = params.leanF_p_h;
		heightKey = "leanF_h";
		heightOptions = const_var.dimensionsLeanLHF;

		hasDoubleLegShowKey = "leanFHasDoublelegshow";
		hasDoubleLegNameKey = "leanFHasDoublelegName";
		parmasLegKey = "leanF_p_e_l";
		selectedLegType = const_var.leanFLegstype
	}

	if (leanType === "back") {
		width = params.leanB_p_w;
		widthKey = "leanB_w";
		widthOptions = const_var.dimensionsLeanLWB;

		length = params.leanB_p_d;
		lengthKey = "leanB_l";
		lengthOptions = const_var.dimensionsLeanLDB;

		height = params.leanB_p_h;
		heightKey = "leanB_h";
		heightOptions = const_var.dimensionsLeanLHB;

		hasDoubleLegShowKey = "leanBHasDoublelegshow";
		hasDoubleLegNameKey = "leanBHasDoublelegName";
		parmasLegKey = "leanB_p_e_l";
		selectedLegType = const_var.leanBLegstype
	}

	return { width, widthKey, widthOptions, length, lengthKey, lengthOptions, height, heightKey, heightOptions, hasDoubleLegShowKey, hasDoubleLegNameKey, parmasLegKey, selectedLegType };
};

export default RenderLean;
